// extracted by mini-css-extract-plugin
export default {"boxSocial":"style_boxSocial__rFbhE","socialBtn":"style_socialBtn__AIG0o"};